import React from 'react';
import { Link } from 'react-router-dom';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0b2545] via-[#134e6f] to-[#1b6b93]">
      <div className="container mx-auto px-4 py-16">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-6xl font-bold mb-4">
            <span className="text-white">Claim</span><span style={{ color: '#2563eb' }}>Sync</span>
          </h1>
          <p className="text-2xl text-blue-100 mb-2">Business Interruption Calculator</p>
          <p className="text-lg text-blue-200">Generate professional compensation claim reports in minutes</p>
        </div>

        {/* Main Options */}
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 mb-12">
          {/* Demo Option */}
          <div className="bg-white rounded-2xl shadow-2xl p-8 hover:scale-105 transition-transform">
            <div className="bg-yellow-100 text-yellow-800 text-sm font-semibold px-3 py-1 rounded-full inline-block mb-4">
              NO LOGIN REQUIRED
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Try Demo</h2>
            <p className="text-gray-600 mb-6">
              Explore the full application with sample data. See example reports, test the wizard, and understand the workflow.
            </p>
            
            <div className="space-y-3 mb-6">
              <div className="flex items-center text-gray-700">
                <svg className="w-5 h-5 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
                3 Sample Reports
              </div>
              <div className="flex items-center text-gray-700">
                <svg className="w-5 h-5 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
                6-Step Wizard Preview
              </div>
              <div className="flex items-center text-gray-700">
                <svg className="w-5 h-5 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
                No account needed
              </div>
            </div>

            <div className="space-y-3">
              <Link
                to="/demo"
                className="block w-full bg-blue-600 hover:bg-blue-700 text-white text-center font-bold py-4 px-6 rounded-lg shadow-lg transition-colors"
              >
                View Demo Dashboard →
              </Link>
              <Link
                to="/demo-wizard"
                className="block w-full bg-gray-200 hover:bg-gray-300 text-gray-700 text-center font-semibold py-3 px-6 rounded-lg transition-colors"
              >
                Try Demo Wizard
              </Link>
            </div>
          </div>

          {/* Sign In Option */}
          <div className="bg-white rounded-2xl shadow-2xl p-8 hover:scale-105 transition-transform">
            <div className="bg-blue-100 text-blue-800 text-sm font-semibold px-3 py-1 rounded-full inline-block mb-4">
              FULL ACCESS
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Sign In</h2>
            <p className="text-gray-600 mb-6">
              Access your account to create real BI reports, manage your organization, and track all your claims.
            </p>
            
            <div className="space-y-3 mb-6">
              <div className="flex items-center text-gray-700">
                <svg className="w-5 h-5 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
                Generate Real Reports
              </div>
              <div className="flex items-center text-gray-700">
                <svg className="w-5 h-5 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
                Download PDF Reports
              </div>
              <div className="flex items-center text-gray-700">
                <svg className="w-5 h-5 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
                Track Your Claims
              </div>
            </div>

            <div className="space-y-3">
              <Link
                to="/sign-in"
                className="block w-full bg-blue-600 hover:bg-blue-700 text-white text-center font-bold py-4 px-6 rounded-lg shadow-lg transition-colors"
              >
                Sign In to Your Account →
              </Link>
              <Link
                to="/sign-up"
                className="block w-full bg-gray-200 hover:bg-gray-300 text-gray-700 text-center font-semibold py-3 px-6 rounded-lg transition-colors"
              >
                Create New Account
              </Link>
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8">
            <h3 className="text-2xl font-bold text-white mb-6">What is ClaimSync?</h3>
            <p className="text-blue-100 text-lg mb-4">
              ClaimSync automates the complex Standard Business Interruption (BI) process, 
              helping you generate accurate compensation claim reports quickly and efficiently.
            </p>
            <div className="grid md:grid-cols-3 gap-6 mt-8">
              <div className="text-center">
                <div className="text-4xl mb-2">⚡</div>
                <div className="text-white font-semibold">Fast Processing</div>
                <div className="text-blue-200 text-sm">Generate reports in minutes</div>
              </div>
              <div className="text-center">
                <div className="text-4xl mb-2">📊</div>
                <div className="text-white font-semibold">Accurate Calculations</div>
                <div className="text-blue-200 text-sm">100% Excel formula parity</div>
              </div>
              <div className="text-center">
                <div className="text-4xl mb-2">📄</div>
                <div className="text-white font-semibold">Professional PDFs</div>
                <div className="text-blue-200 text-sm">11-page detailed reports</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
